var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.797,
    height: 12.34,
    viewBox: "0 0 10.797 12.34",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4508",
    "data-name": "Path 4508",
    d: "M0,308.438A4.368,4.368,0,0,1,4.3,304H6.5a4.368,4.368,0,0,1,4.3,4.438.728.728,0,0,1-.716.739H.716A.728.728,0,0,1,0,308.438Z",
    transform: "translate(0 -296.837)",
    fill: "#047BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4509",
    "data-name": "Path 4509",
    d: "M96,3.186a3.014,3.014,0,1,1,6.018,0,3.014,3.014,0,1,1-6.018,0Z",
    transform: "translate(-93.611 0)",
    fill: "#888",
    opacity: 0.801
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-4.0b56a10b3405d79030f1402fd18c950a.svg";